import { Text } from '@atom/typography/typography';
import { RouteEnum } from '@enum/route.enum';
import { ColorEnum } from '@enum/style/color.enum';
import { useRouteName } from '@hook/route/use-route-name.hook';

import { useUserVerified } from './user-verified.hook';
import { ButtonLink, UserAlertWrapper } from './user-verified.style';

const SKIP_ROUTE_SHOWING = new Set([
  RouteEnum.ApplicationSetup.name,
  RouteEnum.ApplicationSetupConnectors.name,
  RouteEnum.ApplicationSetupConsumer.name,
  RouteEnum.ApplicationSetupNext.name,
]);

export const UserVerified = () => {
  const { isAuthorized, isVerified, onResend, isLoading, isSuccess } = useUserVerified();
  const currentRoute = useRouteName();

  if (SKIP_ROUTE_SHOWING.has(currentRoute) || isVerified || isAuthorized == false) return null;

  return (
    <UserAlertWrapper
      type={isSuccess ? 'info' : 'warning'}
      message={
        <Text color={ColorEnum.Black100} level='m'>
          {isSuccess && 'Mail with verification link has been sent!'}
          {!isSuccess && (
            <>
              Your email is not verified! Please check your email for verification or
              <ButtonLink disabled={isLoading} onClick={onResend}>
                <Text color={ColorEnum.Inherit} level='m'>
                  click here
                </Text>
              </ButtonLink>
              to resend.
            </>
          )}
        </Text>
      }
    />
  );
};
